export class StarBreathingParticle extends Phaser.GameObjects.Container {
  constructor(scene, x, y) {
    super(scene, x, y);
    scene.add.existing(this);
    // this.stars = [];
    // while (this.stars.length < 2) this._createStar();

    this.particles = this.scene.add.particles(x, y, 'toybox', {
      lifespan: { min: 1000, max: 2000 },
      scale: { start: 1, end: 0 },
      frequency: 0,
      speedX: { min: -20, max: 20 },
      speedY: { min: -20, max: 20 },
      emitZone: {
        type: 'random',
        source: new Phaser.Geom.Circle(0, 0, 100),
      },
      active: false,
      frame: [
        'toyboox_star_1',
        'toyboox_star_2',
        'toyboox_star_3',
        'toyboox_star_4',
        'toyboox_star_5',
        'toyboox_star_6',
      ],
    });
    this.add(this.particles);
  }

  _poolStar(star) {
    star.visible = false;
  }

  addStars(count, x, y) {
    this.particles.active = true;
    this.particles.setPosition(x, y);
    this.particles.explode(count);
  }

  update(delta) {}

  destroy() {
    this.particles.active = false;
    this.particles.destroy();
    super.destroy();
  }
}
